<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
          @click="$router.push(`/vessel/detail/${$route.params.id}`)"
        >
          <h2 class="mb-1">จัดการเรือ</h2>
        </div>
        <!-- <p class="mx-2 mt-2"> <vs-icon size="medium" icon="home"></vs-icon> </p> -->
        <p class="mx-5 mt-2">แก้ไขข้อมูลเรือ</p>
      </div>
    </div>
    <vx-card class="p-5">
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="ยืนยัน"
        back-button-text="ย้อนกลับ"
        next-button-text="ถัดไป"
        @on-complete="checkCardNumber"
      >
        <!-- <form-wizard
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
      > -->
        <!-- tab 1 ข้อมูลเรือ -->
        <tab-content title="ข้อมูลเรือ" class="mb-5">
          <!-- <tab-content title="ข้อมูลเรือ" class="mb-5" :before-change="validatoggleAlertep2" > -->
          <!-- <form data-vv-scope="step-2"> -->
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-4">
              <span class="text-sm">เลขที่รับเอกสาร</span>
              <vs-input
                v-model="documentNo"
                class="w-full"
                name="documentNo"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('documentNo')"
                >กรุณากรอก เลขที่รับเอกสาร</span
              >
            </div>
            <!-- <div class="vx-col md:w-1/3 w-full">
              <v-date-picker
                :buddhist="true"
                class="cursor-pointer"
                v-model="documentDate"
                locale="th"
                v-validate="'required'"
                name="documentDate"
              >
                <vs-input
                  label="วันที่รับเอกสาร*"
                  :value="formateDate(documentDate)"
                  class="w-full mt-4"
                  name="document_date"
                  placeholder="วัน/เดือน/ปี"
                />
              </v-date-picker>
              <span
                class="text-danger text-sm"
                v-show="errors.has('documentDate')"
                >กรุณากรอก วันที่รับเอกสาร</span
              >
            </div> -->
            <div class="vx-col md:w-1/3 w-full mt-4">
              <span class="text-sm">วันที่รับเอกสาร</span>
              <v-date-picker
                :buddhist="true"
                class="cursor-pointer"
                v-model="documentDate"
                locale="th"
                mode="date"
              >
                <template v-slot="{ inputEvents }">
                  <vs-input
                    v-on="inputEvents"
                    :value="formateDate(documentDate)"
                    class="w-full"
                    name="document_date"
                    placeholder="วัน/เดือน/ปี"
                  />
                </template>
              </v-date-picker>
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('documentDate')"
                >กรุณากรอก วันที่รับเอกสาร</span
              >
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <span class="text-sm">สำนักงานสรรพสามิตพื้นที่</span>
              <span class="text-danger text-sm">*</span>
              <form autocomplete="off" class="w-full">
                <vs-select
                  class="w-full select-large"
                  v-model="step2.zone"
                  v-validate="'required'"
                  name="zone"
                  autocomplete
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item.label"
                    v-for="(item, index) in zone"
                    class="w-full"
                  />
                </vs-select>
              </form>
              <span class="text-danger text-sm" v-show="errors.has('zone')"
                >กรุณาเลือก สำนักงานสรรพสามิตพื้นที่</span
              >
            </div>

            <div class="vx-col w-full">
              <div class="demo-alignment">
                <span>ประเภทเรือ:</span>
                <div class="flex">
                  <vs-radio
                    class="mr-5"
                    v-model="checkboxVesselType"
                    vs-value="vessel"
                    >เรือประมง</vs-radio
                  >
                  <vs-radio
                    class="mr-5"
                    v-model="checkboxVesselType"
                    vs-value="tanker"
                  >
                    เรือบรรทุกน้ำมัน
                  </vs-radio>
                  <vs-radio
                    class="mr-5"
                    v-model="checkboxVesselType"
                    vs-value="serialTanker"
                  >
                    เรือบรรทุกน้ำมันต่อเนื่อง
                  </vs-radio>
                  <vs-radio
                    class="mr-5"
                    v-model="checkboxVesselType"
                    vs-value="forwardTanker"
                  >
                    เรือสถานีบริการน้ำมัน
                  </vs-radio>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <vs-input
                label="ชื่อผู้ควบคุมเรือ / ไต๋เรือ / ผู้ทำการประมง"
                v-model="step2.ownerName"
                class="w-full mt-4"
                name="owner_name"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('owner_name')"
                >{{ errors.first("owner_name") }}</span
              >
            </div>
            <div class="vx-col md:w-1/3 w-full mt-4">
              <span class="text-sm">เลขบัตรประชาชน</span>
              <span class="text-danger text-sm">*</span>
              <vs-input
                id="card_id"
                v-model="vesselCardNumbe"
                class="w-full"
                v-validate="'min:17'"
                maxlength="17"
                name="card_number"
                placeholder="X-XXXX-XXXXX-XX-X"
                @change="checkCardNumber()"
              />
              <!-- v-validate="'required|min:17'" -->
              <span v-if="toggleValidate" class="text-danger text-sm"
                >เลขบัตรประชาชนไม่ถูกต้อง</span
              >
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <vs-input
                id="mmsi"
                label="MMSI"
                v-model="step2.mmsi"
                class="w-full mt-4"
                v-validate="'numeric|min:9'"
                maxlength="9"
                name="vessel_mmsi"
              />
              <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('vessel_mmsi')"
                >{{ errors.first("vessel_mmsi") }}</span
              > -->
            </div>

            <!-- เลขทะเบียนเรือสรรพสามิต -->
            <!-- <div class="vx-col md:w-1/4 w-full">
              <vs-input
                label="เลขทะเบียนเรือสรรพสามิต"
                v-model="step2.registrationExcise"
                class="w-full mt-4"
                v-validate="'required|numeric|min:10'"
                maxlength="10"
                name="registration_excise"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('registration_excise')"
                >{{ errors.first("registration_excise") }}</span
              >
            </div> -->
            <div
              class="vx-col md:w-1/4 w-full"
              v-show="
                checkboxVesselType == 'tanker' ||
                checkboxVesselType == 'serialTanker' ||
                checkboxVesselType == 'forwardTanker'
              "
            >
              <vs-input
                id="id_imo"
                label="IMO"
                v-model="step2.imo"
                class="w-full mt-4"
                v-validate="'numeric'"
                name="vessel_imo"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('vessel_imo')"
                >กรุณากรอกเป็นตัวเลขเท่านั้น</span
              >
            </div>
            <div class="vx-col md:w-1/3 w-full mt-4">
              <span class="text-sm">ชื่อเรือ</span>
              <span class="text-danger text-sm">*</span>
              <vs-input
                v-model="step2.name"
                class="w-full"
                name="vessel_name"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('vessel_name')"
                >{{ errors.first("vessel_name") }}</span
              >
            </div>
            <div class="vx-col md:w-1/3 w-full">
              <!-- <vs-input
                label="วัตถุประสงค์ในการใช้เรือ"
                v-model="step2.objective"
                class="w-full mt-4"
                v-validate="'required'"
                name="vessel_purpose"
              /> -->
              <div class="flex">
                <form autocomplete="off" class="w-full">
                  <vs-select
                    :class="[
                      toggleObjectiveOther == true
                        ? 'w-full mt-4'
                        : 'w-full mt-4',
                    ]"
                    label="วัตถุประสงค์ในการใช้เรือ"
                    v-model="step2.objective"
                    @change="onObjectiveOther"
                    name="vessel_purpose"
                    autocomplete
                  >
                    <!-- v-validate="'required'" -->
                    <vs-select-item
                      value="ทำการประมง"
                      text="ทำการประมง"
                      class="w-full"
                    />
                    <vs-select-item
                      value="ทำการค้า"
                      text="ทำการค้า"
                      class="w-full"
                    />
                    <vs-select-item value="อื่นๆ" text="อื่นๆ" class="w-full" />
                  </vs-select>
                </form>
                <vs-input
                  v-show="!toggleObjectiveOther"
                  label="ระบุ วัตถุประสงค์อื่นๆ"
                  v-model="step2.otherObjective"
                  class="w-full mt-4 ml-5"
                  name="other"
                />
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('vessel_purpose')"
                >{{ errors.first("vessel_purpose") }}</span
              >
            </div>
            <div class="vx-col md:w-1/3 w-full">
              <vs-input
                label="หมายเลขทะเบียนเรือ"
                v-model="step2.registrationNumber"
                class="w-full mt-4"
                v-validate="'min:9'"
                name="registration_number"
                maxlength="9"
              />
              <!-- v-validate="'required|min:9'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('registration_number')"
                >{{ errors.first("registration_number") }}</span
              >
            </div>
            <div
              class="vx-col md:w-1/4 w-full"
              v-show="checkboxVesselType == 'vessel'"
            >
              <vs-input
                id="id_oil"
                label="รหัสรับน้ำมัน"
                v-model="step2.receiveOilCode"
                class="w-full mt-4"
                v-validate="'min:10'"
                name="receiveOil_code"
                maxlength="10"
                placeholder="XX-XX-XXXX"
                @keyup="checkReceiveOilCode()"
              />
              <!-- v-validate="'required|min:10'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('receiveOil_code')"
                >{{ errors.first("receiveOil_code") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <!-- <vs-input
                label="เมืองท่าที่ขึ้นทะเบียนเรือ"
                v-model="step2.portName"
                class="w-full mt-4"
                v-validate="'required'"
                name="port_name"
              /> -->
              <form autocomplete="off" class="w-full">
                <vs-select
                  class="w-full mt-4 select-large"
                  label="เมืองท่าที่ขึ้นทะเบียนเรือ"
                  v-model="step2.portName"
                  name="port_name"
                  autocomplete
                >
                  <!-- v-validate="'required'" -->
                  <vs-select-item
                    :key="index"
                    :value="item.portName"
                    :text="item.portName"
                    v-for="(item, index) in portNameList"
                    class="w-full"
                  />
                </vs-select>
              </form>
              <span
                class="text-danger text-sm"
                v-show="errors.has('port_name')"
                >{{ errors.first("port_name") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vs-input
                label="ชื่อเรียกขาน"
                v-model="step2.subName"
                class="w-full mt-4"
                name="sub_name"
                placeholder="Call Sign"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('sub_name')"
                >{{ errors.first("sub_name") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <div class="flex">
                <form autocomplete="off" class="w-full">
                  <vs-select
                    :class="[
                      toggleMaterialOther == true
                        ? 'w-full mt-4'
                        : 'w-full mt-4',
                    ]"
                    label="วัสดุตัวเรือ"
                    v-model="step2.material"
                    @change="onMaterialOther"
                    name="material"
                    autocomplete
                  >
                    <!-- v-validate="'required'" -->
                    <vs-select-item value="ไม้" text="ไม้" class="w-full" />
                    <vs-select-item value="เหล็ก" text="เหล็ก" class="w-full" />
                    <vs-select-item value="อื่นๆ" text="อื่นๆ" class="w-full" />
                  </vs-select>
                </form>
                <vs-input
                  v-show="!toggleMaterialOther"
                  label="ระบุ วัสดุอื่นๆ"
                  v-model="step2.otherMaterial"
                  class="w-full mt-4 ml-5"
                  name="other"
                />
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('material')"
                >{{ errors.first("material") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="size"
                label="ขนาดเรือ ความยาวตลอดลำเมตร"
                v-model="step2.size"
                class="w-full mt-4"
                name="size"
                placeholder="(เมตร)"
                @keyup="onkeyupNumber($event, 'size', null)"
              />
              <!-- v-validate="'required'" -->
              <span class="text-danger text-sm" v-show="errors.has('size')">{{
                errors.first("size")
              }}</span>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="width"
                label="ความกว้าง"
                v-model="step2.width"
                class="w-full mt-4"
                name="width"
                placeholder="(เมตร)"
                @keyup="onkeyupNumber($event, 'width', null)"
              />
              <!-- v-validate="'required'" -->
              <span class="text-danger text-sm" v-show="errors.has('width')">{{
                errors.first("width")
              }}</span>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="depth"
                label="ความลึก"
                v-model="step2.depth"
                class="w-full mt-4"
                name="depth"
                placeholder="(เมตร)"
                @keyup="onkeyupNumber($event, 'depth', null)"
              />
              <!-- v-validate="'required'" -->
              <span class="text-danger text-sm" v-show="errors.has('depth')">{{
                errors.first("depth")
              }}</span>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="tonGross"
                label="ตันกรอส"
                v-model="step2.tonGross"
                class="w-full mt-4"
                name="ton_gross"
                @keyup="onkeyupNumber($event, 'tonGross', null)"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('ton_gross')"
                >{{ errors.first("ton_gross") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="tonNet"
                label="ตันเนต"
                v-model="step2.tonNet"
                class="w-full mt-4"
                name="ton_net"
                @keyup="onkeyupNumber($event, 'tonNet', null)"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('ton_net')"
                >{{ errors.first("ton_net") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="machineType"
                label="ชนิดเครื่องจักร"
                v-model="step2.machineType"
                class="w-full mt-4"
                name="machine_type"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('machine_type')"
                >{{ errors.first("machine_type") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                label="ชื่อเครื่อง"
                v-model="step2.machineName"
                class="w-full mt-4"
                name="machine_name"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('machine_name')"
                >{{ errors.first("machine_name") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="machineNumber"
                label="จำนวนเครื่อง"
                v-model="step2.machineNumber"
                class="w-full mt-4"
                maxlength="3"
                name="machine_number"
                @keyup="onkeyupNumber($event, 'machineNumber', null)"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('machine_number')"
                >{{ errors.first("machine_number") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="engineNumber"
                label="จำนวนสูบ"
                v-model="step2.engineNumber"
                class="w-full mt-4"
                maxlength="3"
                name="engine_number"
                @keyup="onkeyupNumber($event, 'engineNumber', null)"
              />
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('engine_number')"
                >{{ errors.first("engine_number") }}</span
              >
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-input
                id="engineSize"
                label="ขนาดเครื่องยนต์"
                v-model="step2.engineSize"
                class="w-full mt-4"
                name="engine_size"
                placeholder="(กิโลวัตต์)"
                @keyup="onkeyupNumber($event, 'engineSize', null)"
              />
              <!-- v-validate="'required'" maxlength="5" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('engine_size')"
                >{{ errors.first("engine_size") }}</span
              >
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                id="capacity"
                label="ปริมาตรความจุถังน้ำมัน ( ใช้สำหรับเรือ )"
                v-model="step2.capacity"
                class="w-full mt-4"
                name="capacity"
                placeholder="(ลิตร)"
                @keyup="onkeyupNumber($event, 'capacity', null)"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('capacity')"
                >{{ errors.first("capacity") }}</span
              >
            </div>
            <div
              class="vx-col md:w-1/2 w-full"
              v-if="checkboxVesselType != 'vessel'"
            >
              <vs-input
                id="capacityForSale"
                label="ปริมาตรความจุถังบรรทุกน้ำมัน ( กรณีเรือบรรทุกน้ำมัน / เรือสถานีบริการจำหน่ายน้ำมัน )"
                v-model="step2.capacityForSale"
                class="w-full mt-4"
                name="capacity_forsale"
                placeholder="(ลิตร)"
                @keyup="onkeyupNumber($event, 'capacityForSale', null)"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('capacity_forsale')"
                >{{ errors.first("capacity_forsale") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <!-- <vs-input
                label="ประเภทเรือ"
                v-model="step2.vesselType"
                class="w-full mt-4"
                v-validate="'required'"
                name="vessel_type"
              /> -->
              <form autocomplete="off" class="w-full">
                <vs-select
                  class="w-full mt-4 select-large"
                  label="ประเภทเรือ"
                  v-model="step2.vesselType"
                  name="vessel_type"
                  autocomplete
                >
                  <!-- v-validate="'required'" -->
                  <vs-select-item
                    :key="index"
                    :value="item.vesselType"
                    :text="item.vesselType"
                    v-for="(item, index) in vesselTypeList"
                    class="w-full"
                  />
                </vs-select>
              </form>
              <span
                class="text-danger text-sm"
                v-show="errors.has('vessel_type')"
                >{{ errors.first("vessel_type") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <!-- <vs-input
                label="ประเภทการใช้"
                v-model="step2.usageType"
                class="w-full mt-4"
                v-validate="'required'"
                name="usage_type"
              /> -->
              <form autocomplete="off" class="w-full">
                <vs-select
                  class="w-full mt-4 select-large"
                  label="ประเภทการใช้"
                  v-model="step2.usageType"
                  name="usage_type"
                  autocomplete
                >
                  <!-- v-validate="'required'" -->
                  <vs-select-item
                    :key="index"
                    :value="item.usageType"
                    :text="item.usageType"
                    v-for="(item, index) in usageTypeList"
                    class="w-full"
                  />
                </vs-select>
              </form>
              <span
                class="text-danger text-sm"
                v-show="errors.has('usage_type')"
                >{{ errors.first("usage_type") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <v-date-picker
                :buddhist="true"
                class="cursor-pointer"
                v-model="step2.certificateDate"
                locale="th"
                mode="date"
              >
                <template v-slot="{ inputEvents }">
                  <vs-input
                    v-on="inputEvents"
                    label="ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวันที่"
                    :value="formateDate(step2.certificateDate)"
                    class="w-full mt-4"
                    name="certificate_date"
                    placeholder="วัน/เดือน/ปี"
                  />
                </template>
              </v-date-picker>
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('certificate_date')"
                >{{ errors.first("certificate_date") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <v-date-picker
                :buddhist="true"
                class="cursor-pointer"
                v-model="step2.expireDate"
                locale="th"
                mode="date"
              >
                <template v-slot="{ inputEvents }">
                  <vs-input
                    v-on="inputEvents"
                    label="หมดอายุวันที่"
                    :value="formateDate(step2.expireDate)"
                    class="w-full mt-4"
                    name="expire_date"
                    placeholder="วัน/เดือน/ปี"
                  />
                </template>
              </v-date-picker>
              <!-- v-validate="'required'" -->
              <span
                class="text-danger text-sm"
                v-show="errors.has('expire_date')"
                >{{ errors.first("expire_date") }}</span
              >
            </div>

            <div
              class="vx-row w-full mt-10 pl-8"
              v-if="checkboxVesselType == 'vessel'"
            >
              <span>****สำหรับเรือประมง :</span>
            </div>
            <div
              class="vx-row w-full pl-5"
              v-if="checkboxVesselType == 'vessel'"
            >
              <!-- <div class="vx-col md:w-1/4 w-full">
                <vs-input
                  label="หมายเลขอาชญาบัตร"
                  v-model="step2.licenseNumber"
                  class="w-full mt-4"
                  name="license_number"
                  maxlength="9"
                  placeholder="XXXX/XXXX"
                />
              </div> -->
              <div class="vx-col md:w-1/4 w-full">
                <vs-input
                  label="ใบอนุญาตทำการประมง"
                  v-model="step2.fisheriesLicense"
                  class="w-full mt-4"
                  v-validate="'min:12'"
                  name="fisheries_license"
                  maxlength="12"
                  placeholder="XXXXXXXXXXXX"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('fisheries_license')"
                  >{{ errors.first("fisheries_license") }}</span
                >
              </div>
              <div class="vx-col md:w-1/4 w-full">
                <vs-input
                  label="ประเภทเครื่องมือทำการประมง"
                  v-model="step2.toolType"
                  class="w-full mt-4"
                  name="tool_type"
                />
                <!-- <vs-select
                  class="w-full mt-4 select-large"
                  label="ประเภทเครื่องมือทำการประมง"
                  v-model="step2.toolType"
                  name="tool_type"
                  autocomplete
                  v-validate="'required'"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.toolType"
                    :text="item.toolType"
                    v-for="(item, index) in toolTypeList"
                    class="w-full"
                  />
                </vs-select> -->
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('tool_type')"
                  >{{ errors.first("tool_type") }}</span
                >
              </div>
              <div class="vx-col md:w-1/4 w-full">
                <v-date-picker
                  :buddhist="true"
                  class="cursor-pointer"
                  v-model="step2.licenseExpireDate"
                  locale="th"
                  mode="date"
                >
                  <template v-slot="{ inputEvents }">
                    <vs-input
                      v-on="inputEvents"
                      label="หมดอายุวันที่"
                      :value="formateDate(step2.licenseExpireDate)"
                      class="w-full mt-4"
                      name="license_expire_date"
                      placeholder="วัน/เดือน/ปี"
                    />
                  </template>
                </v-date-picker>
                <!-- v-validate="'required'" -->
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('license_expire_date')"
                  >{{ errors.first("license_expire_date") }}</span
                >
              </div>
            </div>
          </div>
          <!-- </form> -->
        </tab-content>

        <!-- ภส.05-08/2 -->
        <tab-content
          title="ภส.05-08/2"
          class="mb-5"
          v-if="
            checkboxVesselType != 'vessel' &&
            checkboxVesselType != 'forwardTanker'
          "
        >
          <b class="mt-5"
            >แบบคำขอลงทะเบียนเป็นผู้จำหน่ายน้ำมันดีเซลที่เสียภาษีในอัตราศูนย์ในเขตต่อเนื่องของราชอาณาจักร</b
          >
          <div class="ml-10">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <vs-input
                  label="เลขที่รับเอกสาร"
                  v-model="documentBNo"
                  class="w-full mt-4"
                  name="documentBNo"
                />
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <v-date-picker
                  mode="date"
                  :buddhist="true"
                  class="cursor-pointer"
                  v-model="documentBDate"
                  locale="th"
                  name="documentBDate"
                >
                  <template v-slot="{ inputEvents }">
                    <vs-input
                      v-on="inputEvents"
                      label="วันที่รับเอกสาร"
                      :value="formateDate(documentBDate)"
                      class="w-full mt-4"
                      name="document_b_date"
                      placeholder="วัน/เดือน/ปี"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
            <!-- <p class="mt-3">มีความประสงค์ขอลงทะเบียนเป็นผู้ขนส่งน้ำมันดีเซลที่ได้รับการเสียภาษีในอัตราศูนย์ในเขตต่อเนื่องของราชอาณาจักร โดยนำออกจาก</p>
            <div class="my-3">
              <vs-radio
                class="mr-5 ml-2"
                v-model="exportOilType"
                vs-value="industry"
              >โรงอุสาหกรรม</vs-radio>
              <vs-radio
                class="mr-5"
                v-model="exportOilType"
                vs-value="oilStorage"
              >สถานที่เก็บน้ำมัน</vs-radio>
            </div> -->

            <p class="my-3">
              ขอลงทะเบียนเป็น
              <u>{{
                checkboxVesselType == "tanker"
                  ? "เรือบรรทุกน้ำมัน"
                  : "เรือบรรทุกน้ำมันต่อเนื่อง"
              }}</u>
            </p>

            <vs-row v-for="(item, index) in oils" :key="index">
              <vs-col
                class="mb-5 mt-6"
                vs-type="flex"
                vs-lg="2"
                vs-sm="12"
                vs-xs="12"
              >
                <p>{{ index + 1 }}.</p>
                <vs-input
                  class="w-full"
                  label="ชื่อ/ชนิดของน้ำมัน"
                  v-model="oils[index].name"
                  :name="`oil_name${index}`"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_name${index}`)"
                  >กรุณากรอกชื่อ/ชนิดของน้ำมัน</span
                >
              </vs-col>
              <vs-col class="mb-5 mt-6" vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-input
                  class="w-full"
                  label="จากโรงอุตสาหกรรม/เรือบรรทุกน้ำมัน (ชื่อ)"
                  min="1"
                  v-model="oils[index].industry"
                  :name="`oil_industry${index}`"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_industry${index}`)"
                  >กรุณากรอกชื่อโรงอุตสาหกรรม/เรือบรรทุกน้ำมัน</span
                >
              </vs-col>
              <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-input
                  class="w-full"
                  label="ไปยังสถานีบริการจำหน่ายน้ำมันในเขตต่อเนื่อง/เรือบรรทุกน้ำมันต่อเนื่อง (ชื่อ)"
                  min="1"
                  v-model="oils[index].forwardTanker"
                  :name="`oil_forward_tanker${index}`"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_forward_tanker${index}`)"
                  >กรุณากรอกชื่อสถานีบริการจำหน่ายน้ำมันในเขตต่อเนื่อง/เรือบรรทุกน้ำมันต่อเนื่อง</span
                >
              </vs-col>
              <vs-col class="mb-5" vs-lg="2" vs-sm="12" vs-xs="12">
                <vs-input
                  id="oil_volume"
                  class="w-full"
                  label="ประมาณการการจำหน่ายน้ำมันต่อปี (ลิตร)"
                  v-model="oils[index].volume"
                  :name="`oil_volume${index}`"
                  @keyup="onkeyupNumber($event, 'oils', index)"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_volume${index}`)"
                  >กรุณากรอกประมาณการการจำหน่ายน้ำมันต่อปี</span
                >
              </vs-col>
              <vs-col class="flex mb-5 mt-12" vs-lg="2" vs-sm="12" vs-xs="12">
                <vs-button
                  v-if="oils.length != 1"
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-minus"
                  @click="deleteOtherTool(index)"
                  class="mx-1"
                ></vs-button>
                <vs-button
                  v-if="index == oils.length - 1"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="addOtherTool()"
                ></vs-button>
              </vs-col>
            </vs-row>
          </div>
        </tab-content>

        <!-- ภส.05-08/1 -->
        <tab-content
          title="ภส.05-08/1"
          class="mb-5"
          v-else-if="
            checkboxVesselType != 'vessel' &&
            checkboxVesselType == 'forwardTanker'
          "
        >
          <b class="mt-5"
            >แบบคำขอลงทะเบียนเป็นผู้จำหน่ายน้ำมันดีเซลที่เสียภาษีในอัตราศูนย์ในเขตต่อเนื่องของราชอาณาจักร
            สำหรับสถานีบริการจำหน่ายน้ำมัน</b
          >
          <div class="ml-10">
            <div class="vx-row pl-8">
              <div class="vx-col md:w-1/3 w-full">
                <vs-input
                  label="เลขที่รับเอกสาร"
                  v-model="documentANo"
                  class="w-full mt-4"
                  name="documentANo"
                />
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <v-date-picker
                  mode="date"
                  :buddhist="true"
                  class="cursor-pointer"
                  v-model="documentADate"
                  locale="th"
                  name="documentDate"
                >
                  <template v-slot="{ inputEvents }">
                    <vs-input
                      v-on="inputEvents"
                      label="วันที่รับเอกสาร"
                      :value="formateDate(documentADate)"
                      class="w-full mt-4"
                      name="document_a_date"
                      placeholder="วัน/เดือน/ปี"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
            <p class="my-3">
              มีความประสงค์ขอลงทะเบียนเป็นผู้ขนส่งน้ำมันดีเซลที่ได้รับการเสียภาษีในอัตราศูนย์
              เพื่อจำหน่ายในเขตต่อเนื่องของราชอาณาจักร
            </p>
            <vs-row v-for="(item, index) in oils" :key="index">
              <vs-col
                class="mb-5 mt-8"
                vs-type="flex"
                vs-lg="1"
                vs-sm="12"
                vs-xs="12"
              >
                <p class="ml-20">{{ index + 1 }}.</p>
              </vs-col>
              <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-input
                  class="w-full"
                  label="ชื่อ/ชนิดของน้ำมัน"
                  v-model="oils[index].name"
                  :name="`oil_name${index}`"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_name${index}`)"
                  >กรุณากรอกชื่อ/ชนิดของน้ำมัน</span
                >
              </vs-col>
              <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-input
                  class="w-full"
                  label="ซื้อ/รับ ผู้ประกอบอุตสาหกรรม (ระบุชื่อ)"
                  min="1"
                  v-model="oils[index].industry"
                  :name="`oil_industry${index}`"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_industry${index}`)"
                  >กรุณากรอกซื้อ/รับ ผู้ประกอบอุตสาหกรรม</span
                >
              </vs-col>
              <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-input
                  id="oil_volume"
                  class="w-full"
                  label="ประมาณการการจำหน่ายน้ำมันต่อปี (ลิตร)"
                  v-model="oils[index].volume"
                  :name="`oil_volume${index}`"
                  @keyup="onkeyupNumber($event, 'oils', index)"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`oil_volume${index}`)"
                  >กรุณากรอกประมาณการการจำหน่ายน้ำมันต่อปี</span
                >
              </vs-col>
              <vs-col class="flex mb-5 mt-6" vs-lg="2" vs-sm="12" vs-xs="12">
                <vs-button
                  v-if="oils.length != 1"
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-minus"
                  @click="deleteOtherTool(index)"
                  class="mx-1"
                ></vs-button>
                <vs-button
                  v-if="index == oils.length - 1"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="addOtherTool()"
                ></vs-button>
              </vs-col>
            </vs-row>
          </div>
        </tab-content>

        <!-- tab 3 รูปเรือ -->
        <tab-content title="รูปเรือ" class="mb-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
              <div class="box" id="preview">
                <div v-if="vesselImage">
                  <img :src="vesselImage" class="img-show" />
                </div>
                <div v-else>
                  <img :src="this.step3.imageNameUrl" class="img-show" />
                </div>
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onVesselImageChange.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <input
                  ref="onVesselImageChange"
                  type="file"
                  accept=".jpeg,.png,.jpg,GIF"
                  :hidden="true"
                  @change="onVesselImageChange"
                  name="vessel_image"
                />
                <!-- v-validate="'required'"
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('vessel_image')"
                  >{{ errors.first("vessel_image") }}</span
                > -->
              </div>
              <h6 class="ml-5 mt-5">รูปที่ 1 ชื่อเรือ / เลขทะเบียนเรือ</h6>
            </div>
            <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
              <div class="box" id="preview">
                <div v-if="rightVesselImage">
                  <img :src="rightVesselImage" class="img-show" />
                </div>
                <div v-else>
                  <img :src="this.step3.imageRightUrl" class="img-show" />
                </div>
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onRightVesselImageChange.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <input
                  ref="onRightVesselImageChange"
                  type="file"
                  accept=".jpeg,.png,.jpg,GIF"
                  :hidden="true"
                  @change="onRightVesselImageChange"
                  name="right_vessel_image"
                />
                <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('right_vessel_image')"
                  >{{ errors.first("right_vessel_image") }}</span
                > -->
              </div>
              <h6 class="ml-5 mt-5">รูปที่ 2 รูปเรือทั้งลำ (ด้านข้างขวา)</h6>
            </div>
            <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
              <div class="box" id="preview">
                <div v-if="leftVesselImage">
                  <img :src="leftVesselImage" class="img-show" />
                </div>
                <div v-else>
                  <img :src="this.step3.imageLeftUrl" class="img-show" />
                </div>
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onLeftVesselImageChange.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <input
                  ref="onLeftVesselImageChange"
                  type="file"
                  accept=".jpeg,.png,.jpg,GIF"
                  :hidden="true"
                  @change="onLeftVesselImageChange"
                  name="left_vessel_image"
                />
                <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('left_vessel_image')"
                  >{{ errors.first("left_vessel_image") }}</span
                > -->
              </div>
              <h6 class="ml-5 mt-5">รูปที่ 3 รูปเรือทั้งลำ (ด้านข้างซ้าย)</h6>
            </div>
            <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
              <div class="box" id="preview">
                <div v-if="AISImage">
                  <img :src="AISImage" class="img-show" />
                </div>
                <div v-else>
                  <img :src="this.step3.imageAisUrl" class="img-show" />
                </div>
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onAISImageChange.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <input
                  ref="onAISImageChange"
                  type="file"
                  accept=".jpeg,.png,.jpg,GIF"
                  :hidden="true"
                  @change="onAISImageChange"
                  name="AIS_image"
                />
                <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('AIS_image')"
                  >{{ errors.first("AIS_image") }}</span
                > -->
              </div>
              <h6 class="ml-5 mt-5">
                รูปที่ 4 จุดที่จะขอติดตั้งอุปกรณ์ระบบ AIS
              </h6>
            </div>

            <div
              class="vx-col w-full mb-5 mt-10"
              align="center"
              v-if="checkboxVesselType != 'vessel'"
            >
              <div class="box" id="preview">
                <div v-if="MeasuringSystemImage">
                  <img :src="MeasuringSystemImage" class="img-show" />
                </div>
                <div v-else>
                  <img
                    :src="this.step3.imageMeasuringSystemUrl"
                    class="img-show"
                  />
                </div>
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onMeasuringSystemImageChange.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <input
                  ref="onMeasuringSystemImageChange"
                  type="file"
                  accept=".jpeg,.png,.jpg,GIF"
                  :hidden="true"
                  @change="onMeasuringSystemImageChange"
                  name="measuring_system_image"
                />
                <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('measuring_system_image')"
                  >{{ errors.first("measuring_system_image") }}</span
                > -->
              </div>
              <h6 class="ml-5 mt-5">รูปที่ 5 จุดที่จะขอติดตั้งระบบมาตรวัด</h6>
            </div>
            <!-- <vs-row class="mt-5 mb-5">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-checkbox class="mt-5" v-model="isConfirm"
                  >ยืนยันว่าข้อมูลถูกต้อง และเป็นความจริง</vs-checkbox
                >
              </vs-col>
            </vs-row> -->
          </div>
        </tab-content>

        <!-- tab 3 รูปเรือ -->
        <tab-content title="เอกสารประกอบคำขอ" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full" align="center">
              <div class="demo-alignment px-20 pb-6 flex justify-center">
                <div
                  v-for="(item, index) in documents"
                  :key="index"
                  class="mt-5"
                  align="center"
                >
                  <vs-chip closable @click="deleteDocument(index, item)">
                    <vs-avatar
                      icon-pack="feather"
                      icon="icon-file"
                      class="my-2 ml-2"
                      style="height: 20px; width: 20px"
                    />
                    <a :href="item.endpoint" target="_blank"
                      >เอกสารประกอบคำขอ-{{ index + 1 }}
                    </a> </vs-chip
                  ><br />
                </div>
              </div>

              <div
                v-if="documentFiles.length != 0"
                class="demo-alignment px-20 flex content-center justify-center"
              >
                <div v-for="(item, index) in documentFiles" :key="index">
                  <vs-chip @click="remove(index)" closable>
                    <vs-avatar
                      v-if="item.type == 'application/pdf'"
                      icon-pack="feather"
                      icon="icon-file"
                      class="m-3"
                      style="height: 30px; width: 30px"
                    />
                    <!-- <vs-avatar v-else :src="documentFilesURL[index]" align="center" class="h-24 min-h-full w-24 max-w-full" /> -->
                    <img
                      v-else
                      :src="documentFilesURL[index]"
                      class="m-3"
                      style="height: 100px; max-width: 150px"
                    />
                    <span>{{ item.name }} </span>
                  </vs-chip>
                </div>
              </div>
              <div v-else class="box" id="preview">
                <img
                  src="../../../assets/icons/cloud-img.png"
                  width="200"
                  height="200"
                />
              </div>
              <div>
                <vs-button
                  icon-pack="feather"
                  icon="icon-upload"
                  class="mt-10"
                  color="primary"
                  @click="$refs.onChangeFiles.click()"
                >
                  <span class="d-none d-sm-block">อัปโหลดรูป</span>
                </vs-button>
                <p class="mt-2" style="color: gray; font-size: 12px">
                  *อัปโหลดได้ไม่เกิน 20 ไฟล์ และเป็น .jpeg, .png, .jpg, .pdf
                  เท่านั้น
                </p>

                <input
                  v-if="documents.length == 0"
                  ref="onChangeFiles"
                  type="file"
                  accept=".jpeg,.png,.jpg,.GIF,.pdf"
                  :hidden="true"
                  @change="onChangeFiles"
                  v-validate="'required'"
                  name="files"
                  multiple="multiple"
                />
                <input
                  v-else
                  ref="onChangeFiles"
                  type="file"
                  accept=".jpeg,.png,.jpg,.GIF,.pdf"
                  :hidden="true"
                  @change="onChangeFiles"
                  name="files"
                  multiple="multiple"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('files')"
                  >{{ errors.first("files") }}</span
                >
              </div>
              <h6 class="mt-5">อัปโหลดเอกสารลงทะเบียนประกอบคำขอ</h6>
            </div>
          </div>
        </tab-content>

        <!-- tab 5 content -->
        <!-- <tab-content title="ยืนยันการแก้ไขข้อมูลเรือ" class="mb-5">
          <OTP/>
        </tab-content> -->
      </form-wizard>
    </vx-card>

    <!-- <div class="demo-alignment">
      <vs-popup title="ยืนยันการแก้ข้อมูลเรือ" :active.sync="isConfirmEdit">
        <OTP
          v-if="isConfirmEdit"
          @onClosedEdit="onClosedEdit"
          :active="isConfirmEdit"
          :info="data"
        ></OTP>
      </vs-popup>
    </div> -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from "sweetalert2";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";
import { ENDPOINT } from "../../../constants/endpoint.js";
// import OTP from "../formOTP/FormOTPEditVessel.vue";

// For custom error message
import { Validator } from "vee-validate";
import { DICT_VESSEL } from "../../../mock-data/form-validate.js";
// register custom messages
Validator.localize("en", DICT_VESSEL);
import vSelect from "vue-select";
import { formatNumber } from "@/utils/index";
import { mapState } from "vuex";

export default {
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    "v-select": vSelect,
    // OTP,
  },
  data() {
    return {
      formatNumber,
      step2: {},
      step3: {
        imageNameUrl: "",
        imageRightUrl: "",
        imageLeftUrl: "",
        imageAisUrl: "",
        imageMeasuringSystemUrl: "",
      },
      url: null,
      vesselImage: null,
      rightVesselImage: null,
      leftVesselImage: null,
      AISImage: null,
      MeasuringSystemImage: null,
      documentFilesURL: [],
      documentNo: null,
      documentDate: null,

      vesselImageFile: null,
      rightVesselImageFile: null,
      leftVesselImageFile: null,
      AISImageFile: null,
      MeasuringSystemImageFile: null,
      documentFiles: [],

      portNameList: [],
      toolTypeList: [],
      usageTypeList: [],
      vesselTypeList: [],
      test: [],
      cardNumber: null,
      toggleCard: false,
      vesselCardNumbe: "",
      isConfirmEdit: false,
      data: null,
      checkboxVesselType: null,

      toggleObjectiveOther: true,
      toggleMaterialOther: true,
      zone: "",
      toggleValidate: false,

      //
      exportOilType: "industry",
      documentANo: "",
      documentADate: null,
      documentBNo: "",
      documentBDate: null,
      oils: [
        {
          name: null,
          industry: null,
          forwardTanker: null,
          volume: null,
        },
      ],
      documents: [],
    };
  },
  computed: {
    ...mapState({
      registrationFormData: (state) => state.vessels.vessel,
    }),
  },
  async mounted() {
    await this.$store.dispatch(`vessels/setVesselById`, this.$route.params.id);
    await this.getPortName();
    await this.getToolType();
    await this.getUsageType();
    await this.getVesselType();
    await this.getZone();
    // await this.$store.dispatch("rts/getVesselGroupFishing");
    // await this.$store.dispatch("rts/getVesselGroupTanker");


    console.log("this.registrationFormData ", this.registrationFormData);
    this.headerInfo = this.registrationFormData.registration.createdBy;
    const recivedOilCode = this.registrationFormData.receiveOilCode;
    const vessel = this.registrationFormData.vessel;
    const registrationForm = this.registrationFormData;
    this.step2 = vessel;
    console.log(
      "registrationForm.documentDate ::::: ",
      registrationForm.documentDate
    );
    this.documentNo = registrationForm.documentNo;
    this.documentDate = registrationForm.documentDate;
    this.documentANo = registrationForm.documentANo;
    this.documentADate = registrationForm.documentADate;
    this.documentBNo = registrationForm.documentBNo;
    this.documentBDate = registrationForm.documentBDate;
    
    this.step2.receiveOilCode =
      recivedOilCode == "null" ? null : recivedOilCode;
    this.step2.certificateDate =
      vessel.certificateDate &&
      moment(vessel.certificateDate).format("YYYY-MM-DD");
    this.step2.expireDate =
      vessel.expireDate && moment(vessel.expireDate).format("YYYY-MM-DD");
    this.step2.licenseExpireDate =
      vessel.licenseExpireDate &&
      moment(vessel.licenseExpireDate).format("YYYY-MM-DD");
    this.checkboxVesselType = vessel.type;
    this.step2.zone = _.find(this.zone, { id: vessel.zone.id });

    if (vessel.objective != "ทำการประมง" && vessel.objective != "ทำการค้า") {
      this.step2.otherObjective = vessel.objective;
      this.step2.objective = "อื่นๆ";
      this.toggleObjectiveOther = false;
    }

    if (this.step2.material != "ไม้" && this.step2.objective != "เหล็ก") {
      this.step2.otherMaterial = vessel.material;
      this.step2.material = "อื่นๆ";
      this.toggleMaterialOther = false;
    }

    this.step2.size = vessel.size && formatNumber(vessel.size);
    this.step2.width = vessel.width && formatNumber(vessel.width);
    this.step2.depth = vessel.depth && formatNumber(vessel.depth);
    this.step2.tonGross = vessel.tonGross && formatNumber(vessel.tonGross);
    this.step2.tonNet = vessel.tonNet && formatNumber(vessel.tonNet);
    this.step2.machineNumber =
      vessel.machineNumber && formatNumber(vessel.machineNumber);
    this.step2.engineNumber =
      vessel.engineNumber && formatNumber(vessel.engineNumber);
    this.step2.engineSize =
      vessel.engineSize && formatNumber(vessel.engineSize);
    this.step2.capacity = vessel.capacity && formatNumber(vessel.capacity);
    this.step2.capacityForSale =
      vessel.capacityForSale && formatNumber(vessel.capacityForSale);

    // console.log("this.step2.objective ", this.step2);
    console.log("vessel ", vessel);
    console.log("registrationForm ", registrationForm);

    this.step3.imageNameUrl = ENDPOINT.GET_IMAGE + vessel.imageNameUrl;
    this.step3.imageRightUrl = ENDPOINT.GET_IMAGE + vessel.imageRightUrl;
    this.step3.imageLeftUrl = ENDPOINT.GET_IMAGE + vessel.imageLeftUrl;
    this.step3.imageAisUrl = ENDPOINT.GET_IMAGE + vessel.imageAisUrl;
    this.step3.imageMeasuringSystemUrl =
      ENDPOINT.GET_IMAGE + vessel.imageMeasuringSystemUrl;
    this.vesselCardNumbe = await this.formatCardNumber(vessel.cardNumber);

    if (vessel.oils.length != 0) {
      this.oils = vessel.oils;
      for (const [index, oil] of vessel.oils.entries()) {
        this.oils[index].volume = formatNumber(oil.volume);
      }
    }

    const documents = this.registrationFormData.documents;
    for (const document of documents) {
      this.documents.push({
        id: document.id,
        endpoint: ENDPOINT.GET_IMAGE + document.fileName,
        fileName: document.fileName,
      });
    }
    // console.log("registration ", this.$store.state.vessels.vessel);

    this.checkNumber();
    $("[id*=card_id]").on("keypress", function () {
      const value = $(this).val();
      if (value.length == 1) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 6) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 12) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 15) {
        $(this).val($(this).val() + "-");
      }
      console.log($(this).val());
    });
  },
  methods: {
    checkNumber() {
      $(document).ready(function () {
        $("#card_id, #mmsi").bind("keypress", function (evt) {
          var key = String.fromCharCode(evt.which || evt.charCode);
          if (/[\d -]/.test(key) === false) return evt.preventDefault();
        });
        $(
          "#size, #width, #depth, #tonGross, #tonNet, #machineNumber , #engineNumber, #engineSize, #capacity ,#capacityForSale, #oil_volume"
        ).bind("keypress", function (evt) {
          var key = String.fromCharCode(evt.which || evt.charCode);
          if (/[\d , .]/.test(key) === false) return evt.preventDefault();
        });
      });
    },
    formatCardNumber(cardNumber) {
      return `${cardNumber.substring(0, 1)}-${cardNumber.substring(
        1,
        2
      )}${cardNumber.substring(2, 3)}${cardNumber.substring(
        3,
        4
      )}${cardNumber.substring(4, 5)}-${cardNumber.substring(
        5,
        6
      )}${cardNumber.substring(6, 7)}${cardNumber.substring(
        7,
        8
      )}${cardNumber.substring(8, 9)}${cardNumber.substring(
        9,
        10
      )}-${cardNumber.substring(10, 11)}${cardNumber.substring(
        11,
        12
      )}-${cardNumber.substring(12, 13)}`;
    },
    async getPortName() {
      await this.$store.dispatch("users/getPortName");
      this.portNameList = this.$store.state.users.portName;
      // console.log(this.portNameList);
    },
    async getToolType() {
      await this.$store.dispatch("users/getToolType");
      this.toolTypeList = this.$store.state.users.toolType;
    },
    async getUsageType() {
      await this.$store.dispatch("users/getUsageType");
      this.usageTypeList = this.$store.state.users.usageType;
    },
    async getVesselType() {
      await this.$store.dispatch("users/getVesselType");
      this.vesselTypeList = this.$store.state.users.vesselType;
    },
    async getZone() {
      await this.$store.dispatch("users/getZone");
      this.zone = this.$store.state.users.zone;
    },
    formSubmitted() {
      let cutDash = this.vesselCardNumbe.split("-");
      let cutVesselCardNumbe = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`;

      for (const oil of this.oils) {
        if (oil.volume) {
          oil.volume = this.resetFormatNumber(oil.volume);
        }
      }
      // console.log(this.$store.state.vessels.vessel.registration);
      console.log("doc : ", this.documentFiles, this.documentFiles.length);
      console.log("this.oils ", this.oils);
      console.log("this.checkboxVesselType :::> ", this.checkboxVesselType);

      this.$validator.validateAll().then((result) => {
        console.log("this.$validator ----- ", this.$validator);
        if (result && this.toggleValidate != true) {
          // if form have no errors

          this.isConfirmEdit = true;
          const vesselImg = {
            imgNameVessel: this.vesselImageFile,
            imgRightVessel: this.rightVesselImageFile,
            imgLeftVessel: this.leftVesselImageFile,
            imgInstallVessel: this.AISImageFile,
            imgMeasuringSystem: this.MeasuringSystemImageFile,
          };
          // console.log("vesselImg__________ : ", vesselImg);
          Swal.fire({
            title: "ยืนยันการแก้ไขข้อมูลเรือ",
            text: "",
            icon: "question",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.data = {
                id: this.step2.id,
                registrationFormId: this.registrationFormData.id, // registration ID
                receiveOilCode: this.step2.receiveOilCode,
                ownerName: this.step2.ownerName,
                cardNumber: cutVesselCardNumbe,
                name: this.step2.name,
                objective:
                  this.step2.objective == "อื่นๆ"
                    ? this.step2.otherObjective
                    : this.step2.objective,
                registrationNumber: this.step2.registrationNumber,
                portName: this.step2.portName,
                subName: this.step2.subName,
                material:
                  this.step2.material == "อื่นๆ"
                    ? this.step2.otherMaterial
                    : this.step2.material,
                size: this.resetFormatNumber(this.step2.size),
                width: this.resetFormatNumber(this.step2.width),
                depth: this.resetFormatNumber(this.step2.depth),
                tonGross: this.resetFormatNumber(this.step2.tonGross),
                tonNet: this.resetFormatNumber(this.step2.tonNet),
                machineType: this.step2.machineType,
                machineName: this.step2.machineName,
                machineNumber: this.resetFormatNumber(this.step2.machineNumber),
                engineNumber: this.resetFormatNumber(this.step2.engineNumber),
                engineSize: this.resetFormatNumber(this.step2.engineSize),
                capacity: this.resetFormatNumber(this.step2.capacity),
                capacityForSale: this.resetFormatNumber(
                  this.step2.capacityForSale
                ),
                vesselType: this.step2.vesselType,
                certificateDate: this.step2.certificateDate,
                expireDate: this.step2.expireDate,
                licenseNumber: this.step2.licenseNumber,
                fisheriesLicense: this.step2.fisheriesLicense,
                licenseExpireDate: this.step2.licenseExpireDate,
                toolType: this.step2.toolType,
                usageType: this.step2.usageType,
                phoneNumber: this.headerInfo.phoneNumber,
                type: this.checkboxVesselType,
                vesselImg,
                zone: this.step2.zone,
                mmsi: this.step2.mmsi ? this.step2.mmsi : null,
                documentNo: this.documentNo,
                documentDate: this.documentDate,
                documentANo: this.documentANo,
                documentADate: this.documentADate,
                documentBNo: this.documentBNo,
                documentBDate: this.documentBDate,
                imo: this.step2.imo,
              };

              console.log("mmsi ", this.step2.mmsi);
              // console.log(
              //   'oil >> ',
              //   this.oils[0].name,
              //   this.oils[0].name != null
              // );
              if (this.oils[0].name != null) {
                this.data.oils = this.oils;
              }
              console.log("headerInfo >> ", this.headerInfo);

              this.$store.dispatch("vessels/updateVessel", {
                data: this.data,
                user: this.headerInfo,
              });
              if (this.documentFiles.length != 0) {
                this.$vs.loading();
                this.$store
                  .dispatch("vessels/addDocuments", {
                    registrationFormId: this.data.registrationFormId,
                    files: this.documentFiles,
                  })
                  .then(() => {
                    this.$vs.loading.close();
                  });
              }
            }
          });
        } else {
          // form have errors
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
          });
        }
      });
    },
    onVesselImageChange(e) {
      const file = e.target.files[0];
      this.vesselImage = URL.createObjectURL(file);
      this.vesselImageFile = file;
    },
    onRightVesselImageChange(e) {
      const file = e.target.files[0];
      this.rightVesselImage = URL.createObjectURL(file);
      this.rightVesselImageFile = file;
    },
    onLeftVesselImageChange(e) {
      const file = e.target.files[0];
      this.leftVesselImage = URL.createObjectURL(file);
      this.leftVesselImageFile = file;
    },
    onAISImageChange(e) {
      const file = e.target.files[0];
      this.AISImage = URL.createObjectURL(file);
      this.AISImageFile = file;
    },
    onMeasuringSystemImageChange(e) {
      const file = e.target.files[0];
      this.MeasuringSystemImage = URL.createObjectURL(file);
      this.MeasuringSystemImageFile = file;
    },
    checkCardNumber() {
      console.log("this is test");
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = this.vesselCardNumbe.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }

      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }

      if (chk == Validchk) {
        this.toggleValidate = false;
        this.formSubmitted();
        return true;
      } else {
        this.toggleValidate = true;
        this.formSubmitted();
        return false;
      }
    },
    onClosedEdit() {
      this.isConfirmEdit = false;
      // this.getData();
    },
    formateDate(date) {
      console.log(
        "formateDate >>>>> ",
        date,
        moment(date).add(543, "year").format("DD/MM/YYYY")
      );
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    onObjectiveOther() {
      console.log("this is other", this.step2.objective);
      if (this.step2.objective == "อื่นๆ") {
        this.toggleObjectiveOther = false;
      } else {
        this.toggleObjectiveOther = true;
      }
    },
    onMaterialOther() {
      console.log("this is other", this.step2.material);
      if (this.step2.material == "อื่นๆ") {
        this.toggleMaterialOther = false;
      } else {
        this.toggleMaterialOther = true;
      }
    },
    addOtherTool() {
      this.oils.push({
        name: null,
        industry: null,
        forwardTanker: null,
        volume: null,
      });
    },
    deleteOtherTool(index) {
      this.oils.splice(index, 1);
    },
    onkeyupNumber(data, type, index) {
      const value = data.target._value;
      if (value) {
        const textWithOutComma = value.replace(/,/g, "");
        // const numberWithComma = Number(textWithOutComma).toLocaleString()
        let cutDot = value.split(".");
        if ((cutDot.length > 1 && cutDot[1] == "") || cutDot[1] == 0) {
          if (cutDot[1] == 0) {
            return value;
          } else {
            return;
          }
        } else if (
          cutDot.length > 1 &&
          cutDot[1].substring(cutDot[1].length - 1) == 0
        ) {
          return value;
        }

        let number = Number(textWithOutComma).toLocaleString();
        if (type == "oils") {
          this.oils[index].volume = number;
        } else if (type == "size") {
          this.step2.size = number;
        } else if (type == "width") {
          this.step2.width = number;
        } else if (type == "depth") {
          this.step2.depth = number;
        } else if (type == "tonGross") {
          this.step2.tonGross = number;
        } else if (type == "tonNet") {
          this.step2.tonNet = number;
        } else if (type == "machineNumber") {
          this.step2.machineNumber = number;
        } else if (type == "engineNumber") {
          this.step2.engineNumber = number;
        } else if (type == "engineSize") {
          this.step2.engineSize = number;
        } else if (type == "capacity") {
          this.step2.capacity = number;
        } else if (type == "capacityForSale") {
          this.step2.capacityForSale = number;
        }
      }
    },
    onChangeFiles(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.documentFiles = [];
      this.documentFilesURL = [];
      console.log("files.length  ", files.length);
      if (files.length > 20) {
        Swal.fire({
          icon: "warning",
          title: "ไฟล์มีจำนวนเกินที่กำหนด",
          text: "กรุณาอัปโหลดไฟล์ไม่เกิน 20 ไฟล์",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        for (const item of e.target.files) {
          this.documentFiles.push(item);
          const url = URL.createObjectURL(item);
          this.documentFilesURL.push(url);
        }
      }
    },
    remove(index) {
      this.documentFiles.splice(index, 1);
      this.documentFilesURL.splice(index, 1);
    },
    deleteDocument(index, item) {
      // console.log("deleteDocument :: ", index, item);
      Swal.fire({
        title: "ยืนยันการลบเอกสารประกอบคำขอลงทะเบียน",
        text: "",
        icon: "question",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.documents.splice(index, 1);
          this.$store.dispatch("vessels/deleteDocument", item.id);
        }
      });
    },
    resetFormatNumber(data) {
      console.log(data);
      if (data) {
        let cutDashs = data.split(",");
        let value = "";
        for (const [i, cutDash] of cutDashs.entries()) {
          value += `${cutDash}`;
        }
        return value;
      }
    },
    onkeyupOilsVolume(data, index) {
      if (data.target._value) {
        let cutDashs = data.target._value.split(",");
        let value = "";
        for (const [i, cutDash] of cutDashs.entries()) {
          value += `${cutDash}`;
        }
        this.oils[index].volume = formatNumber(Number(value));
      }
    },
  },
  watch: {
    vesselCardNumbe: function () {
      let cutDash = this.vesselCardNumbe.split("-");
      let cardNum = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`;
      this.vesselCardNumbeCutDash = cardNum;
    },
  },
};
</script>
<style lang="css" scoped>
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  max-width: 370px;
  height: 225px;
}
</style>
